"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedNextLocalesAndIsoLocales = exports.allowedNextIsoLocales = exports.allowedNextLocales = exports.DeIsoLocale = exports.IeIsoLocale = exports.NzIsoLocale = exports.AuIsoLocale = exports.GbIsoLocale = exports.UsaIsoLocale = exports.CadIsoLocale = exports.DeLocales = exports.IeLocales = exports.NzLocales = exports.AuLocales = exports.GbLocales = exports.UsaLocales = exports.CadLocales = exports.Locales = exports.I18nLocales = void 0;
var I18nLocales;
(function (I18nLocales) {
    I18nLocales["FR"] = "fr";
    I18nLocales["EN"] = "en";
    I18nLocales["ES"] = "es";
    I18nLocales["DE"] = "de";
})(I18nLocales || (exports.I18nLocales = I18nLocales = {}));
var Locales;
(function (Locales) {
    Locales["FR"] = "FR";
    Locales["EN"] = "EN";
    Locales["ES"] = "ES";
    Locales["DE"] = "DE";
})(Locales || (exports.Locales = Locales = {}));
var CadLocales;
(function (CadLocales) {
    CadLocales["FR"] = "FR";
    CadLocales["EN"] = "EN";
})(CadLocales || (exports.CadLocales = CadLocales = {}));
var UsaLocales;
(function (UsaLocales) {
    UsaLocales["EN"] = "EN";
    UsaLocales["ES"] = "ES";
})(UsaLocales || (exports.UsaLocales = UsaLocales = {}));
var GbLocales;
(function (GbLocales) {
    GbLocales["EN"] = "EN";
})(GbLocales || (exports.GbLocales = GbLocales = {}));
var AuLocales;
(function (AuLocales) {
    AuLocales["EN"] = "EN";
})(AuLocales || (exports.AuLocales = AuLocales = {}));
var NzLocales;
(function (NzLocales) {
    NzLocales["EN"] = "EN";
})(NzLocales || (exports.NzLocales = NzLocales = {}));
var IeLocales;
(function (IeLocales) {
    IeLocales["EN"] = "EN";
})(IeLocales || (exports.IeLocales = IeLocales = {}));
var DeLocales;
(function (DeLocales) {
    DeLocales["DE"] = "DE";
})(DeLocales || (exports.DeLocales = DeLocales = {}));
var CadIsoLocale;
(function (CadIsoLocale) {
    CadIsoLocale["FR"] = "fr-CA";
    CadIsoLocale["EN"] = "en-CA";
})(CadIsoLocale || (exports.CadIsoLocale = CadIsoLocale = {}));
var UsaIsoLocale;
(function (UsaIsoLocale) {
    UsaIsoLocale["EN"] = "en-US";
    UsaIsoLocale["ES"] = "es-US";
})(UsaIsoLocale || (exports.UsaIsoLocale = UsaIsoLocale = {}));
var GbIsoLocale;
(function (GbIsoLocale) {
    GbIsoLocale["EN"] = "en-GB";
})(GbIsoLocale || (exports.GbIsoLocale = GbIsoLocale = {}));
var AuIsoLocale;
(function (AuIsoLocale) {
    AuIsoLocale["EN"] = "en-AU";
})(AuIsoLocale || (exports.AuIsoLocale = AuIsoLocale = {}));
var NzIsoLocale;
(function (NzIsoLocale) {
    NzIsoLocale["EN"] = "en-NZ";
})(NzIsoLocale || (exports.NzIsoLocale = NzIsoLocale = {}));
var IeIsoLocale;
(function (IeIsoLocale) {
    IeIsoLocale["EN"] = "en-IE";
})(IeIsoLocale || (exports.IeIsoLocale = IeIsoLocale = {}));
var DeIsoLocale;
(function (DeIsoLocale) {
    DeIsoLocale["DE"] = "de-DE";
    DeIsoLocale["EN"] = "en-DE";
})(DeIsoLocale || (exports.DeIsoLocale = DeIsoLocale = {}));
exports.allowedNextLocales = Object.values(I18nLocales);
exports.allowedNextIsoLocales = [
    ...Object.values(GbIsoLocale),
    ...Object.values(UsaIsoLocale),
    ...Object.values(CadIsoLocale),
    ...Object.values(AuIsoLocale),
    ...Object.values(IeIsoLocale),
    ...Object.values(DeIsoLocale),
];
exports.allowedNextLocalesAndIsoLocales = [...exports.allowedNextLocales, ...exports.allowedNextIsoLocales];
